import PropTypes from 'prop-types';
import React from 'react';

export const GrabCentsWrapper = ({ softOrder, Component, ...rest }) => {
  const details = {
    tacticName: 'GRAB_CENTS',
    category: 'Exit',
    type: 'Grab Cents',
    domain: 'Profit/Loss',
  };
  //this is for when grab cents becomes a position price trail once all open orders are filled
  const trailAmount = softOrder.trailAmount;
  const priceToBreak = softOrder.priceToBreak;

  return <Component details={details} trailAmount={trailAmount} priceToBreak={priceToBreak} {...rest}/>;
};

GrabCentsWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.shape({
    priceToBreak: PropTypes.any,
    trailAmount: PropTypes.any
  })
};

